/**
 * Toaster — mounts the coss / base-ui `ToastProvider` once at the root.
 *
 * The `toastManager` singleton exported from `components/ui/toast.tsx`
 * is the one the `errors.toastFromError` helper calls into. Mounting
 * the provider activates the viewport + portal so those calls become
 * visible toasts.
 *
 * Positioned bottom-right because the sidebar lives on the left. If
 * the shell ever gains a right-rail (e.g. the AI pane peek), revisit.
 */
import { ToastProvider } from '@/components/ui/toast';
import type { ReactElement, ReactNode } from 'react';

export function Toaster({ children }: { children: ReactNode }): ReactElement {
  return (
    <ToastProvider position="bottom-right" limit={3}>
      {children}
    </ToastProvider>
  );
}
